// extracted by mini-css-extract-plugin
export default {"path":"breadcrumbs_path__Ovoyr"};